<template>
  <v-app>
    <v-main>
      <ModalSleep v-if="isIdle" />
      <router-view v-if="!isIdle" />
      <div v-if="!isIdle">
        <!-- Btn France -->
        <v-btn @click="swapLanguage('fr')" class="btnLangFrance"> </v-btn>

        <!-- Btn Italy -->
        <v-btn @click="swapLanguage('it')" class="btnLangItaly"> </v-btn>

        <!-- Btn Corsica -->
        <v-btn @click="swapLanguage('co')" class="btnLangCorsica"> </v-btn>

        <!-- Btn Map -->
        <v-btn
          @click="
            t;
            $router.push({
              name: 'Map',
            });
          "
          class="btnMap"
        >
        </v-btn>

        <!-- Btn Infos -->
        <v-btn @click="displayInfos()" class="btnInfo"> </v-btn>

        <!-- Overlay des infos -->
        <v-overlay :absolute="absolute" :value="displayInfo" light>
          <v-card
            class="mx-auto"
            max-width="50vw"
            outlined
            light
            v-on-clickaway="displayInfos"
            @click="displayInfos"
          >
            <v-list-item three-line light>
              <v-list-item-content light>
                <div class="overline mb-4" light>
                  {{ $t("infoModal_title") }}
                </div>
                <v-list-item-title class="headline mb-1" light>{{
                  $t("infoModal_heading")
                }}</v-list-item-title>
                <v-list-item-subtitle light class="text-nowrap">{{
                  $t("infoModal_content")
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-overlay>

        <!-- Btn Crédits -->
        <v-btn @click="displayCredits()" class="btnCredit"> </v-btn>

        <!-- Overlay des crédits -->
        <v-overlay :absolute="absolute" :value="displayCredit" light>
          <v-card
            class="mx-auto"
            max-width="50vw"
            outlined
            light
            v-on-clickaway="displayCredits"
            @click="displayCredits"
          >
            <v-list-item three-line light>
              <v-list-item-content light>
                <div class="overline mb-4" light>
                  {{ $t("creditModal_title") }}
                </div>
                <v-list-item-title class="headline mb-1" light>{{
                  $t("creditModal_heading")
                }}</v-list-item-title>
                <v-list-item-subtitle light class="text-nowrap">{{
                  $t("creditModal_content")
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-overlay>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import ModalSleep from "@/components/ModalSleep.vue";
import { mixin as clickaway } from "vue-clickaway";
import { mapState } from "vuex";
export default {
  mixins: [clickaway],
  name: "App",
  components: {
    ModalSleep,
  },
  data() {
    return {
      displayInfo: false,
      displayCredit: false,
      absolute: true,
    };
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    ...mapState({
      publicPath: "publicPathState",
    }),
  },
  methods: {
    displayInfos() {
      this.displayInfo = !this.displayInfo;
    },
    displayCredits() {
      this.displayCredit = !this.displayCredit;
    },
    swapLanguage(selectedLang) {
      if (this.$i18n.locale !== selectedLang) {
        this.$i18n.locale = selectedLang;
        console.log("La langue a bien été changée en " + selectedLang + " !");
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: "CenturyGothic";
  src: local("CenturyGothic"), url(./fonts/CenturyGothic.ttf) format("truetype");
}

::-webkit-scrollbar {
  width: 0px; /* Remove scrollbar space */
}

.btnLangFrance {
  background-image: url("./assets/maquette/buttons/btnFrance.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 15px;
  right: 4px;
  width: 117px;
  height: 117px !important;
}

.btnLangItaly {
  background-image: url("./assets/maquette/buttons/btnItaly.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 152px;
  right: 4px;
  width: 118px;
  height: 118px !important;
}

.btnLangCorsica {
  background-image: url("./assets/maquette/buttons/btnCorsica.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 290px;
  right: 4px;
  width: 117px;
  height: 117px !important;
}

.btnMap {
  background-image: url("./assets/maquette/buttons/btnMap.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 565px;
  right: 4px;
  width: 118px;
  height: 118px !important;
}

.btnInfo {
  background-image: url("./assets/maquette/buttons/btnInfos.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  bottom: 140px;
  right: 4px;
  width: 118px;
  height: 118px !important;
}

.btnCredit {
  background-image: url("./assets/maquette/buttons/btnCredits.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  bottom: 3px;
  right: 4px;
  width: 118px;
  height: 118px !important;
}

.text-nowrap {
  -webkit-line-clamp: unset !important;
}
</style>
